var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',{ref:"header",class:_vm.isAmbassador ? 'ambassador-header' : ''},[_c('div',[_vm._t("left")],2),_c('div',[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }